// extracted by mini-css-extract-plugin
export var close = "modal-window-module--close--IdXvC";
export var content = "modal-window-module--content--jhPr-";
export var questionnaire = "modal-window-module--questionnaire--o1gdY";
export var root = "modal-window-module--root--Vh0Ch";